module.exports = __webpack_public_path__ + "img/heartFilled.baebd9bb.svg";